import { TComputePositionConfigs, TContext } from '../types'
import flip from './flip'
import getPosition from './getPosition'
import hide from './hide'
import shift from './shift'

export default function computePosition(
    reference: HTMLElement,
    popup: HTMLElement,
    configs: TComputePositionConfigs
): TContext {
    const { position, placement, scrollableParents, popupConfigs } = configs

    /*
     * Make popup flip
     * */
    const flippedPlacement = flip({
        position,
        reference,
        popup,
        scrollableParents,
        placement,
        popupConfigs
    })

    const shiftValues = shift({
        position,
        reference,
        popup,
        scrollableParents,
        placement,
        popupConfigs
    })

    const isReferenceHidden = hide({
        reference,
        scrollableParents,
        popupConfigs
    })

    const args = {
        placement: flippedPlacement,
        position,
        reference,
        popup,
        popupConfigs,
        shiftValues
    }
    const { x, y } = getPosition(args)
    return {
        x,
        y,
        position,
        placement: flippedPlacement,
        isReferenceHidden
    }
}
